import { render, staticRenderFns } from "./InfoGrid.vue?vue&type=template&id=7bd16fda&scoped=true&"
import script from "./InfoGrid.vue?vue&type=script&lang=js&"
export * from "./InfoGrid.vue?vue&type=script&lang=js&"
import style0 from "./InfoGrid.vue?vue&type=style&index=0&id=7bd16fda&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7bd16fda",
  null
  
)

export default component.exports